/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { IconButton } from '@radix-ui/themes';

import { styled, use, useCallback } from 'fierry/react';

import Logo from 'solis/react/icon/logo';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';


const Button = styled(IconButton)`

  margin: 0;
  background: transparent;

  cursor: pointer;

  &:active ${Logo}
  {
    --icon-transition-duration: 0s;
    --icon-fill-normal: var(--icon-color-6);
  }
`;


const OnClick = (event, dispatch) =>
{
  dispatch.pushForeground({ route: Routes.Dashboard });
};


const Component = ({ onClick, ...props }) =>
(
  <Button {...props} size = '3' variant = 'ghost' radius = 'full' onClick = {onClick} aria-label = 'Home'>
    <Logo accent size = {28} />
  </Button>
);


export default (props) =>
{
  const onClick = useCallback(OnClick, [ use(Navigation.Dispatch) ]);

  return <Component {...props} onClick = {onClick} />;
};
